import { AxiosRequestConfig, AxiosResponse } from 'axios'

import { Api } from 'common/api/api'
import { apiConfig } from 'common/api/api.config'
import { CreateCompanyParams } from 'common/types/company'
import { CheckInit, CheckStepResponse, InitialCompanyResponse } from 'common/types/initialConfig'
import { NetworkDownNoMessageResponse } from 'common/types/security'
import { InitialUserData } from 'common/types/user'

const ENDPOINT = '/initialConfiguration'

class InitialConfigApi extends Api {
  public constructor(config: AxiosRequestConfig) {
    super(config)

    // this middleware is been called right before the http request is made.
    this.interceptors.request.use((param: AxiosRequestConfig) => ({
      ...param
    }))

    // this middleware is been called right bjsonplaceholder.typicode.comefore the response is get it by the method that triggers the request
    this.interceptors.response.use((param: AxiosResponse) => ({
      ...param
    }))

    Object.setPrototypeOf(this, InitialConfigApi.prototype)
    this.checkInit = this.checkInit.bind(this)
    this.createSuperUserCompany = this.createSuperUserCompany.bind(this)
  }

  public async checkInit(): Promise<boolean | NetworkDownNoMessageResponse> {
    try {
      const res: AxiosResponse<CheckInit> = await this.get<string, AxiosResponse<CheckInit>>(
        `${ENDPOINT}/checkInit/`
      )
      return res.data.initialized as boolean
    } catch (error) {
      return { networkDown: true }
    }
  }
  public async createSuperUserCompany(data: InitialUserData): Promise<any> {
    try {
      const res: AxiosResponse<any> = await this.post(`${ENDPOINT}/createSuperUserCompany/`, data)
      return this.success(res)
    } catch (error) {
      throw error
    }
  }
  public async createInitialCompany(data: CreateCompanyParams): Promise<InitialCompanyResponse> {
    try {
      const res: AxiosResponse<InitialCompanyResponse> = await this.post(
        `${ENDPOINT}/createInitialCompany/`,
        data
      )
      return this.success(res)
    } catch (error) {
      throw error
    }
  }
  public async updateInitialLicence(licence: string, companyId: string): Promise<any> {
    try {
      const data = {
        licence,
        companyId
      }
      const res: AxiosResponse<any> = await this.put(`${ENDPOINT}/updateInitialLicence/`, data)
      return this.success(res)
    } catch (error) {
      throw error
    }
  }
  public async checkStep(): Promise<CheckStepResponse> {
    try {
      const res: AxiosResponse<CheckStepResponse> = await this.get(`${ENDPOINT}/checkStep/`)
      return this.success(res)
    } catch (error) {
      throw error
    }
  }
}

export const initialConfigApi = new InitialConfigApi(apiConfig)
